"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var rc_tooltip_1 = __importDefault(require("rc-tooltip"));

require("rc-tooltip/assets/bootstrap.css");

var uiContext_1 = __importDefault(require("./uiContext"));

var Scale;

(function (Scale) {
  Scale[Scale["Full"] = 1] = "Full";
  Scale[Scale["Half"] = 2] = "Half";
  Scale[Scale["Quarter"] = 4] = "Quarter";
})(Scale || (Scale = {}));

var ItemList = function ItemList(props) {
  var components = props.components,
      onSelect = props.onSelect;
  var finalUI = react_1.useContext(uiContext_1.default);

  var _a = react_1.useState(Scale.Full),
      scale = _a[0],
      setScale = _a[1];

  var getRowHeight = function getRowHeight() {
    if (components.length <= scale) {
      return 'auto';
    }

    return scale * 100 + "%";
  };

  var styles = {
    1: {
      transformStyle: {
        height: getRowHeight(),
        maxHeight: '100%'
      },
      boxStyle: {
        width: '100%'
      },
      outerStyle: {}
    },
    2: {
      transformStyle: {
        width: '200%',
        height: getRowHeight(),
        transform: 'scale(.5) translate(-50%, -50%)'
      },
      boxStyle: {
        width: '50%'
      },
      outerStyle: {
        fontSize: '200%'
      }
    },
    4: {
      transformStyle: {
        width: '400%',
        height: getRowHeight(),
        transform: 'scale(.25) translate(-150%, -150%)'
      },
      boxStyle: {
        width: '25%'
      },
      outerStyle: {
        fontSize: '400%'
      }
    }
  };
  var _b = styles[scale],
      transformStyle = _b.transformStyle,
      boxStyle = _b.boxStyle,
      outerStyle = _b.outerStyle;
  var maxComponents = 25;
  var maxErrorMsg = "This result set includes items which cannot be displayed. Please \n  reduce the result set to less than " + maxComponents + " by filtering or searching.";
  var elems = components.slice(0, maxComponents).map(function (Component) {
    return react_1.default.createElement(finalUI.ItemBoxWrapper, {
      style: boxStyle,
      key: Component.displayName
    }, react_1.default.createElement(finalUI.ItemBox, {
      key: Component.displayName
    }, react_1.default.createElement(finalUI.TitleWrapper, {
      style: outerStyle
    }, Component.title || Component.displayName || 'Untitled'), react_1.default.createElement("div", {
      className: "bl-outerTransform bl-relative bl-w-full bl-bg-white"
    }, react_1.default.createElement(Component, null)), react_1.default.createElement(rc_tooltip_1.default, {
      placement: "rightBottom",
      mouseLeaveDelay: 0,
      overlayStyle: {
        opacity: 1
      },
      overlay: react_1.default.createElement(finalUI.ComponentDescriptionWrapper, null, react_1.default.createElement("h3", null, Component.title), react_1.default.createElement(finalUI.ComponentDescriptionStyle, null, react_1.default.createElement("p", null, Component.description)))
    }, react_1.default.createElement(finalUI.ComponentDescriptionIcon, {
      style: outerStyle
    }, "info")), react_1.default.createElement(finalUI.ComponentSelectButton, {
      type: "submit",
      onClick: function onClick() {
        return onSelect([Component.displayName]);
      }
    })));
  });

  var MoreItems = function MoreItems() {
    return react_1.default.createElement(finalUI.ItemBoxWrapper, {
      style: boxStyle
    }, react_1.default.createElement(finalUI.ItemBox, null, react_1.default.createElement(finalUI.TitleWrapper, null, maxErrorMsg)));
  };

  var isActive = function isActive(currentScale) {
    return currentScale === scale ? 'bl-bg-primary bl-text-white' : '';
  };

  return react_1.default.createElement(finalUI.GridListBox, null, react_1.default.createElement(finalUI.ScalingHeader, null, react_1.default.createElement(finalUI.ScalingButtonFull, {
    className: isActive(Scale.Full),
    onClick: function onClick() {
      return setScale(Scale.Full);
    }
  }), react_1.default.createElement(finalUI.ScalingButtonHalf, {
    className: isActive(Scale.Half),
    onClick: function onClick() {
      return setScale(Scale.Half);
    }
  }), react_1.default.createElement(finalUI.ScalingButtonQuarter, {
    className: isActive(Scale.Quarter),
    onClick: function onClick() {
      return setScale(Scale.Quarter);
    }
  })), react_1.default.createElement(finalUI.GridListBoxWrapper, null, react_1.default.createElement(finalUI.GridListBoxInner, {
    style: transformStyle,
    id: "gridlistboxinner"
  }, elems, components.length > maxComponents ? react_1.default.createElement(MoreItems, null) : react_1.Fragment)));
};

exports.default = ItemList;